var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 115,
    viewBox: "0 0 150 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.701 78.0318C124.833 73.0616 129.044 68.8574 134.022 65.73C139.002 68.8593 143.216 73.0629 146.354 78.0318C143.22 83.0065 139.005 87.214 134.022 90.343C129.041 87.2151 124.83 83.0073 121.701 78.0318Z",
    fill: "url(#paint0_linear_357_112885)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.128 96.2793C114.217 92.9643 117.025 90.1604 120.346 88.075C123.669 90.1593 126.481 92.9633 128.573 96.2793C126.48 99.5913 123.672 102.394 120.355 104.484C117.033 102.397 114.221 99.5937 112.128 96.2793Z",
    fill: "#550065"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140.136 96.4941C141.392 94.506 143.079 92.825 145.072 91.5752C147.063 92.8254 148.747 94.5064 149.999 96.4941C148.747 98.4817 147.063 100.163 145.072 101.413C143.079 100.163 141.392 98.4821 140.136 96.4941Z",
    fill: "#FF004C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.728 38.9876C21.0884 43.1378 17.5524 46.6458 13.3788 49.2547C9.20611 46.648 5.67271 43.1394 3.03906 38.9876C5.66611 34.8156 9.2 31.2873 13.3788 28.6646C17.5585 31.2895 21.095 34.8171 23.728 38.9876Z",
    fill: "#550065"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7783 23.6432C30.0237 26.4232 27.6658 28.774 24.8789 30.5221C22.0926 28.7765 19.7373 26.425 17.9888 23.6432C19.7397 20.8608 22.0944 18.5067 24.8789 16.7549C27.6642 18.5089 30.0215 20.8624 31.7783 23.6432Z",
    fill: "url(#paint1_linear_357_112885)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27372 23.4566C7.2215 25.1277 5.80595 26.5409 4.13212 27.5914C2.46309 26.538 1.05129 25.1253 0 23.4566C1.05164 21.7906 2.46351 20.381 4.13212 19.3311C5.80553 20.3781 7.22115 21.7882 8.27372 23.4566Z",
    fill: "#FF004C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8652 57.4057C35.7972 37.0045 53.7794 19.0222 74.1806 4.09022C94.5665 19.0378 112.545 37.0166 127.493 57.4025C112.561 77.8037 94.5786 95.7859 74.1774 110.718C53.767 95.799 35.7841 77.8161 20.8652 57.4057Z",
    fill: "#FF004C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0419 46.042H87.9585V50.1441C87.9585 51.1754 89.196 51.6795 89.9064 50.9462L96.3002 44.5524C96.7585 44.0941 96.7585 43.3837 96.3002 42.9254L89.9064 36.5316C89.196 35.8212 87.9585 36.3254 87.9585 37.3566V41.4587H62.7502C61.4898 41.4587 60.4585 42.4899 60.4585 43.7504V52.917C60.4585 54.1774 61.4898 55.2087 62.7502 55.2087C64.0106 55.2087 65.0419 54.1774 65.0419 52.917V46.042ZM87.9585 68.9587H65.0419V64.8566C65.0419 63.8254 63.8044 63.3212 63.0939 64.0545L56.7002 70.4483C56.2419 70.9066 56.2419 71.617 56.7002 72.0754L63.0939 78.4691C63.8044 79.1795 65.0419 78.6754 65.0419 77.6441V73.542H90.2502C91.5106 73.542 92.5419 72.5108 92.5419 71.2504V62.0837C92.5419 60.8233 91.5106 59.792 90.2502 59.792C88.9898 59.792 87.9585 60.8233 87.9585 62.0837V68.9587Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_357_112885",
    x1: 121.744,
    y1: 78.0379,
    x2: 146.396,
    y2: 78.0445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#967832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFCE6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_357_112885",
    x1: 24844.5,
    y1: 5357.54,
    x2: 24957.6,
    y2: 5470.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#967832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFCE6D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.d09d8764d5ddbafb5e694401c40917dd.svg";
export { ForwardRef as ReactComponent };